import { HTTP, authHeader } from './http-service';

class DataSubjectAccessRequestAssociationService {
  list(dsarId) {
    return HTTP.get(`/DataSubjectAccessRequestAssociation/dsar/${dsarId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  get(dsarId, dsarAssociationId) {
    return HTTP.get(`/DataSubjectAccessRequestAssociation/${dsarAssociationId}/dsar/${dsarId}/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/DataSubjectAccessRequestAssociation`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  update(payload) {
    return HTTP.put(`/DataSubjectAccessRequestAssociation`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  delete(payload) {
    return HTTP.delete(
      `/DataSubjectAccessRequestAssociation/${payload.dsarAssociationId}/dsar/${payload.dsarId}`,
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }
}

export default new DataSubjectAccessRequestAssociationService();
